import {
  ITableFields,
  TABLE_FIELD_ALIGN,
  TABLE_FIELD_TYPE,
} from "../../core-component/ui/ICTable";
import { IPagination } from "../../data/AppInterface";
import {
  TBitValue,
  TReactSetState,
  TSetPaginationFn,
  TUseTranslationTfn,
} from "../../data/AppType";
import {
  DELETE_TAX_CATEGORY,
  GET_ALL_TAX_CATEGORY,
} from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import { ASSIGN_TYPE, BIT_VALUE } from "../../utils/AppEnumerations";
import {
  handleError,
  sweetAlertError,
  sweetAlertSuccess,
} from "../../utils/AppFunctions";

export interface ITaxCategory {
  id: string;
  category_name: string;
  can_individual_assign_to_item: TBitValue;
  created_by: string;
  created_date: string;
  modified_by: string | null;
  modified_date: string | null;
}

export function getTaxCategoryFields<T>(
  actionComponent: (item: T) => JSX.Element,
  t: TUseTranslationTfn
): ITableFields<T>[] {
  return [
    {
      name: t("category_name"),
      key: "category_name",
      sort: true,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("can_individual_assign_to_item"),
      key: "can_individual_assign_to_item",
      sort: true,
      type: TABLE_FIELD_TYPE.status,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-3",
      statusColorClassPair: {
        [BIT_VALUE.One]: "bg-success-muted text-success",
        [BIT_VALUE.Zero]: "bg-danger-muted text-danger",
      },
      statusLabelPair: {
        [BIT_VALUE.One]: ASSIGN_TYPE.Yes,
        [BIT_VALUE.Zero]: ASSIGN_TYPE.No,
      },
    },

    {
      name: t("created_by"),
      key: "created_by",
      sort: false,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("created_date"),
      key: "created_date",
      sort: true,
      type: TABLE_FIELD_TYPE.date,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-2",
    },
    {
      name: t("modified_by"),
      key: "modified_by",
      sort: false,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("modified_date"),
      key: "modified_date",
      sort: true,
      type: TABLE_FIELD_TYPE.date,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-2",
    },

    {
      name: t("action"),
      key: "action",
      sort: false,
      type: TABLE_FIELD_TYPE.custom,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-1",
      component: actionComponent,
    },
  ];
}

export const getAllTaxCategory = async (
  setTaxCategory: TReactSetState<ITaxCategory[]>,
  pagination: IPagination,
  setPagination: TSetPaginationFn,
  search: string
) => {
  try {
    const taxCategoryField = await GET_ALL_TAX_CATEGORY(pagination, search);
    if (
      taxCategoryField &&
      taxCategoryField.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      setTaxCategory(taxCategoryField.data.items);
      setPagination(taxCategoryField.data.pagination);
    } else {
      setTaxCategory([]);
      sweetAlertError({
        message: taxCategoryField.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (error: any) {
    handleError(error, "getAllTaxCategory");
  }
};

export const deleteTaxCategoryField = async (id: string) => {
  try {
    const deletedData = await DELETE_TAX_CATEGORY(id);
    if (deletedData && deletedData.code === DEFAULT_STATUS_CODE_SUCCESS) {
      sweetAlertSuccess({ message: deletedData.message });
      return true;
    } else {
      sweetAlertError({
        message: deletedData.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
      return false;
    }
  } catch (e: any) {
    handleError(e, "deleteTaxCategoryField");
    return false;
  }
};
